import React from "react";
import { Page } from "../../layouts/Page";
import { useHistory, useRouteMatch } from "react-router-dom";
import { Tab, Tabs } from "@blueprintjs/core";
import { ProfileSettings } from "./ProfileSettings";
import { BankAccountSettings } from "./BankAccountSettings";
import { TaxSettings } from "./TaxSettings";
import styles from "./Settings.module.scss";
import { ShippingSettings } from "./ShippingSettings";
import { PoliticalSettings } from "./PoliticalSettings";
import { CustomDomainSettings } from "./CustomDomainSettings";
import { ThemeSettings } from "./ThemeSettings";
import { BillingInformationSettings } from "./BillingInformationSettings";
import { ProgramSettings } from "./ProgramSettings";
import useTutorialsState from "../../hooks/useTutorialsState";

function Settings() {
  const match = useRouteMatch();
  const history = useHistory();
  const { isNmiAccount } = useTutorialsState();

  return (
    <Page title="Profile Page" className={styles.settings}>
      <Tabs
        selectedTabId={match.params.tabId}
        onChange={(tabId) => history.push(`/settings/${tabId}`)}
        large
        vertical
      >
        <Tab
          id="profile"
          title="Profile Information"
          panel={<ProfileSettings />}
        />
        {!isNmiAccount && (
          <Tab
            id="bank-account"
            title="Bank Account"
            panel={<BankAccountSettings />}
          />
        )}
        <Tab id="shipping" title="Shipping" panel={<ShippingSettings />} />
        <Tab
          id="political"
          className={styles.tabTitle}
          panelClassName={styles.entryPanel}
          title="Political"
          panel={<PoliticalSettings />}
        />

        {!isNmiAccount && (
          <Tab
            id="billing"
            title="Billing Information"
            panel={<BillingInformationSettings />}
          />
        )}
        <Tab id="theme" title="Theme" panel={<ThemeSettings />} />
        <Tab
          id="domain"
          className={styles.tabTitle}
          panelClassName={styles.entryPanel}
          title="Custom Domain"
          panel={<CustomDomainSettings />}
        />
        <Tab
          id="program"
          title="Program Highlights"
          panel={<ProgramSettings />}
        />
      </Tabs>
    </Page>
  );
}

export default Settings;
